import React from 'react'
import Tile, { TileProps } from "../tile"
import styles from './GridSizedTile.module.css'

export default function(props: TileProps) {
    return (
        <div className={styles.gridSizedTile}>
            <Tile {...props} />
        </div>
    )
}